import * as React from "react";

export const CommentIcon: React.SFC = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon/Comment/Unread</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon/Comment/Read" transform="translate(-1.000000, -1.000000)">
        <g id="Icon/Comment/Unread">
          <path
            d="M14.66,2.66666667 C14.66,1.93333333 14.0666667,1.33333333 13.3333333,1.33333333 L2.66666667,1.33333333 C1.93333333,1.33333333 1.33333333,1.93333333 1.33333333,2.66666667 L1.33333333,10.6666667 C1.33333333,11.4 1.93333333,12 2.66666667,12 L12,12 L14.6666667,14.6666667 L14.66,2.66666667 Z M12,9.33333333 L4,9.33333333 L4,8 L12,8 L12,9.33333333 Z M12,7.33333333 L4,7.33333333 L4,6 L12,6 L12,7.33333333 Z M12,5.33333333 L4,5.33333333 L4,4 L12,4 L12,5.33333333 Z"
            id="Shape"
            fill="#12A32B"
            fillRule="nonzero"
          />
          <polygon id="Path" points="0 0 16 0 16 16 0 16" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/commentView/CommentIcon.tsx